export function isAppSku(appSku: string): boolean {
    return ['RDC', 'ORV', 'IND', 'SLG'].includes(appSku);
}
